import { render, staticRenderFns } from "./CommonSysSettingConfigForm.vue?vue&type=template&id=24353fcf&"
import script from "./CommonSysSettingConfigForm.vue?vue&type=script&lang=js&"
export * from "./CommonSysSettingConfigForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports